'use client';
import { useEffect, useRef } from 'react';
import drawScatter, { ScatterPoint } from '@/lib/visualisers/scatter';

interface ScatterVisualiserProps {
    points: ScatterPoint[];
    showGrid: boolean;
    xLabel: string;
    yLabel: string;
}

export default function ScatterVisualiser({
    points,
    showGrid,
    xLabel,
    yLabel,
}: ScatterVisualiserProps) {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const c = canvasRef.current;
        if (!c) return;
        drawScatter(c, { points, showGrid, xLabel, yLabel });
    }, [points, showGrid, xLabel, yLabel]);

    return (
        <div className="w-full max-w-[520px] overflow-hidden rounded-lg border-[0.5px] border-line bg-white">
            <canvas
                ref={canvasRef}
                aria-label="Scatter graph"
                className="block h-auto w-full"
            />
        </div>
    );
}
